import * as React from 'react';

/** The stable wrapper stays observed when the sale is hidden, opened or dismissed. */
export default function useMemberBannerHeight(active: boolean) {
  const ref = React.useRef<HTMLDivElement>(null);
  const [height, setHeight] = React.useState(0);
  const useBeforePaint = typeof window === 'undefined' ? React.useEffect : React.useLayoutEffect;
  useBeforePaint(() => {
    const element = ref.current;
    if (!active || !element) {
      setHeight(0);
      return;
    }
    const update = () => setHeight(element.getBoundingClientRect().height);
    update();
    const observer = new ResizeObserver(update);
    observer.observe(element);
    return () => observer.disconnect();
  }, [active]);
  return { ref, height: active ? height : 0 };
}
